import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

export default function NavBar({ cartCount, onCartClick }) {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const navigate = useNavigate();

  return (
    <nav style={{ position: 'fixed', top: 0, left: 0, width: '100vw', zIndex: 3000, background: '#fff', color: '#222', height: 72, borderBottom: '1px solid #e0e0e0' }}>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%', height: '100%', padding: '0 2rem', boxSizing: 'border-box' }}>
        <div
          style={{ position: 'relative', display: 'flex', alignItems: 'center', height: '100%' }}
          onMouseEnter={() => setDropdownOpen(true)}
          onMouseLeave={(e) => {
            // Only close if mouse is leaving to go outside this container and not into the dropdown
            const relatedTarget = e.relatedTarget;
            if (relatedTarget && !e.currentTarget.contains(relatedTarget) && !relatedTarget.closest('.nav-dropdown')) {
              setDropdownOpen(false);
            }
          }}
        >
          <button
            onClick={() => setDropdownOpen(!dropdownOpen)}
            onMouseEnter={() => setDropdownOpen(true)}
            onMouseLeave={(e) => {
              // Only close if mouse is leaving to go outside the parent container
              const relatedTarget = e.relatedTarget;
              if (relatedTarget && !e.currentTarget.parentElement.contains(relatedTarget)) {
                setDropdownOpen(false);
              }
            }}
            style={{ background: 'none', color: '#222', border: 'none', fontSize: 28, cursor: 'pointer', padding: 0, marginRight: 16, display: 'flex', alignItems: 'center', height: '100%', position: 'relative', zIndex: 201 }}
            aria-label="Open menu"
          >
            <span style={{ fontSize: 28, lineHeight: 1 }}>☰</span>
          </button>
          <div 
            className={`nav-dropdown ${dropdownOpen ? 'nav-dropdown-open' : ''}`}
            style={{ 
              position: 'fixed', 
              top: 72, 
              left: 0, 
              background: '#fff', 
              color: '#222', 
              borderRadius: 0, 
              minWidth: 120, 
              width: 200,
              height: 'calc(100vh - 72px)',
              zIndex: 199,
              overflow: 'hidden',
              transformOrigin: 'left center',
              margin: 0,
              padding: '0',
            }}
            onMouseEnter={() => setDropdownOpen(true)}
            onMouseLeave={() => setDropdownOpen(false)}
          >
            <button 
              onClick={() => { navigate('/'); setDropdownOpen(false); }} 
              className="nav-menu-item"
              style={{ display: 'block', padding: '0.5rem 1rem', background: 'none', border: 'none', textAlign: 'left', width: '100%', color: '#222', cursor: 'pointer', transition: 'transform 0.2s ease' }}
            >
              Home
            </button>
          </div>
          {/* Large invisible bridge area to prevent menu from closing */}
          {dropdownOpen && (
            <div 
              style={{ 
                position: 'fixed', 
                top: 0, 
                left: 0, 
                width: '100px', 
                height: '200px', 
                background: 'transparent',
                zIndex: 5
              }}
              onMouseEnter={() => setDropdownOpen(true)}
              onMouseLeave={() => setDropdownOpen(false)}
            />
          )}
        </div>
        <button
          onClick={onCartClick}
          style={{ background: 'none', border: 'none', color: '#222', fontSize: 14, fontWeight: 'bold', cursor: 'pointer', padding: '4px 8px', borderRadius: 8, textTransform: 'uppercase', letterSpacing: '0.5px', display: 'flex', alignItems: 'center', height: '100%', position: 'relative', marginRight: '10px' }}
          aria-label="View cart"
        >
          CART
          {cartCount > 0 && (
            <span style={{ position: 'absolute', top: 8, right: -8, background: '#000', color: '#fff', borderRadius: '50%', padding: '2px 6px', fontSize: 12 }}>{cartCount}</span>
          )}
        </button>
      </div>
      <style>{`
        .nav-dropdown {
          transform: scaleX(0);
          transform-origin: left center;
          transition: transform 0.3s ease;
        }
        
        .nav-dropdown-open {
          transform: scaleX(1);
        }
        
        .nav-menu-item:hover {
          transform: scale(1.03);
        }
        
        /* Responsive Design */
        @media (max-width: 768px) {
          nav {
            height: 60px !important;
          }
          
          nav > div {
            padding: 0.5rem 1rem !important;
          }
          
          .nav-dropdown {
            top: 60px !important;
            left: 0 !important;
            height: calc(100vh - 60px) !important;
            width: 200px !important;
            padding: 0 !important;
            margin: 0 !important;
            transform: scaleX(0) !important;
            transform-origin: left center !important;
          }
          
          .nav-dropdown-open {
            transform: scaleX(1) !important;
          }
        }
        
        @media (max-width: 480px) {
          nav {
            height: 50px !important;
          }
          
          nav > div {
            padding: 0.5rem !important;
          }
          
          .nav-dropdown {
            top: 50px !important;
            left: 0 !important;
            height: calc(100vh - 50px) !important;
            width: 200px !important;
            padding: 0 !important;
            margin: 0 !important;
            transform: scaleX(0) !important;
            transform-origin: left center !important;
          }
          
          .nav-dropdown-open {
            transform: scaleX(1) !important;
          }
          
        }
      `}</style>
    </nav>
  );
} 